import { createContext } from 'react';

interface DataLayerContextProps {
  dataLayer: {
    [key: string]: string | number;
  };
}

export const DataLayerContext = createContext<DataLayerContextProps>({
  dataLayer: {},
});
